export const ROLES = {
  ADMIN: "admin",
  STAFF: "staff",
  VIEWER: "viewer",
};

/** Permission keys used across the UI for conditional rendering */
export const PERMISSIONS = {
  MANAGE_ACCOUNTS: "manage_accounts",
  CREATE_EMPLOYEE: "create_employee",
  CREATE_PAYSLIP: "create_payslip",
  CREATE_INVOICE: "create_invoice",
  CREATE_METADATA: "create_metadata",
  EDIT: "edit",
  DELETE: "delete",
  GENERATE_PDF: "generate_pdf",
  ARCHIVE: "archive",
  MANAGE_METADATA: "manage_metadata",
  MANAGE_YTD: "manage_ytd",
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: Object.values(PERMISSIONS),
  [ROLES.STAFF]: [
    PERMISSIONS.CREATE_EMPLOYEE,
    PERMISSIONS.CREATE_PAYSLIP,
    PERMISSIONS.CREATE_INVOICE,
    PERMISSIONS.CREATE_METADATA,
    PERMISSIONS.EDIT,
    PERMISSIONS.ARCHIVE,
    PERMISSIONS.GENERATE_PDF,
  ],
  [ROLES.VIEWER]: [],
};

export const getRole = () => {
  const role = (localStorage.getItem("user_role") || "").toLowerCase().trim();
  if (Object.values(ROLES).includes(role)) {
    return role;
  }
  return null;
};

export const getAccountId = () => localStorage.getItem("account_id");

export const isAdmin = () => getRole() === ROLES.ADMIN;
export const isStaff = () => getRole() === ROLES.STAFF;
export const isViewer = () => getRole() === ROLES.VIEWER;

export const hasPermission = (permission) => {
  const role = getRole();
  if (!role) return false;
  return (ROLE_PERMISSIONS[role] || []).includes(permission);
};

export const canRender = (permission) => hasPermission(permission);

export const canCreateEmployee = () => canRender(PERMISSIONS.CREATE_EMPLOYEE);
export const canCreatePayslip = () => canRender(PERMISSIONS.CREATE_PAYSLIP);
export const canCreateInvoice = () => canRender(PERMISSIONS.CREATE_INVOICE);
export const canCreateMetadata = () => canRender(PERMISSIONS.CREATE_METADATA);
export const canCreate = () =>
  canCreateEmployee() ||
  canCreatePayslip() ||
  canCreateInvoice() ||
  canCreateMetadata();
export const canEdit = () => canRender(PERMISSIONS.EDIT);
export const canDelete = () => canRender(PERMISSIONS.DELETE);
export const canGeneratePdf = () => canRender(PERMISSIONS.GENERATE_PDF);
export const canManageAccounts = () => canRender(PERMISSIONS.MANAGE_ACCOUNTS);
export const canManageMetadata = () => canRender(PERMISSIONS.MANAGE_METADATA);
export const canArchive = () => canRender(PERMISSIONS.ARCHIVE);
export const canManageYtd = () => canRender(PERMISSIONS.MANAGE_YTD);

export const formatAccountId = (accountId) => {
  if (accountId == null || accountId === "") return "";
  return `#ACC-${accountId}`;
};

export const roleLabel = (role) => {
  switch ((role || "").toLowerCase()) {
    case ROLES.ADMIN:
      return "Admin";
    case ROLES.STAFF:
      return "Staff";
    case ROLES.VIEWER:
      return "Read Only";
    default:
      return role || "—";
  }
};

export const statusLabel = (status) => {
  if (!status) return "—";
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
};
